import classNames from "classnames";

import { IntroProps } from "./types";

import "./styles.scss";

export const Intro = ({ title, subtitle, className, children }: IntroProps) => {
  const classnames = classNames(`intro`, {
    [`${className}`]: className,
    "intro--subtitle": subtitle,
  });

  const renderSubtitle = () => {
    if (!subtitle) {
      return null;
    }

    if (typeof subtitle === "string") {
      return <span className="intro__subtitle">{subtitle}</span>;
    }

    return subtitle;
  };

  if (children) {
    return (
      <div
        data-testid="intro"
        className={classnames}>
        {children}
      </div>
    );
  }

  return (
    <div
      data-testid="intro"
      className={classnames}>
      {title && <h1 className="intro__title">{title}</h1>}
      {renderSubtitle()}
    </div>
  );
};
